/* eslint-disable no-param-reassign */
/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const slider = () => {
  const sliders = document.querySelectorAll('.js-slider');
  const mq = window.matchMedia('(max-width: 63.99em)');
  const slidersInfo = [{}];
  sliders.forEach((el, sliderIndex) => {
    slidersInfo[sliderIndex] = {
      dataId: sliderIndex,
      index: 0,
      xDown: null,
      yDown: null,
      container: null,
      pager: null,
      listItems: null,
      pagerItems: null,
    };
    el.setAttribute('data-id', sliderIndex);
  });

  const translateList = (listItems, index, container) => {
    listItems.style.transform = `translateX(${-index *
      container.offsetWidth}px)`;
  };

  const removeActivePagerItem = pagerItems => {
    pagerItems.forEach(item => {
      item.classList.remove('is-active');
    });
  };

  const getTouches = evt => evt.touches || evt.originalEvent.touches;

  const handleTouchStart = evt => {
    const sliderId = evt.currentTarget.closest('.js-slider').dataset.id;
    const firstTouch = getTouches(evt)[0];
    slidersInfo[sliderId].xDown = firstTouch.clientX;
    slidersInfo[sliderId].yDown = firstTouch.clientY;
  };

  const handleTouchMove = evt => {
    const sliderId = evt.currentTarget.closest('.js-slider').dataset.id;
    if (!slidersInfo[sliderId].xDown || !slidersInfo[sliderId].yDown) {
      return;
    }

    const xUp = evt.touches[0].clientX;
    const yUp = evt.touches[0].clientY;
    const xDiff = slidersInfo[sliderId].xDown - xUp;
    const yDiff = slidersInfo[sliderId].yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        if (
          slidersInfo[sliderId].index <
          slidersInfo[sliderId].listItems.childElementCount - 1
        ) {
          slidersInfo[sliderId].index += 1;
        }
      } else if (slidersInfo[sliderId].index > 0) {
        slidersInfo[sliderId].index -= 1;
      }
      if (slidersInfo[sliderId].pagerItems) {
        removeActivePagerItem(slidersInfo[sliderId].pagerItems);
        slidersInfo[sliderId].pagerItems[
          slidersInfo[sliderId].index
        ].classList.add('is-active');
      }
      translateList(
        slidersInfo[sliderId].listItems,
        slidersInfo[sliderId].index,
        slidersInfo[sliderId].container,
      );
    }

    slidersInfo[sliderId].xDown = null;
    slidersInfo[sliderId].yDown = null;
  };

  if (sliders && mq.matches) {
    sliders.forEach((container, containerIndex) => {
      const pager = container.parentElement.querySelector('.js-slider-pager');
      const listItems = container.parentElement.querySelector(
        '.js-slider-list',
      );
      let pagerItems = null;
      if (pager) {
        pagerItems = pager.querySelectorAll('.js-slider-pager-item');
      }

      if (pager) {
        pagerItems.forEach(page => {
          page.addEventListener('click', e => {
            slidersInfo[containerIndex].index = [...pager.children].indexOf(
              e.target,
            );
            removeActivePagerItem(pagerItems);
            e.target.classList.add('is-active');
            translateList(
              listItems,
              slidersInfo[containerIndex].index,
              container,
            );
          });
        });
      }

      slidersInfo[containerIndex].container = container;
      slidersInfo[containerIndex].pager = pager;
      slidersInfo[containerIndex].listItems = listItems;
      slidersInfo[containerIndex].pagerItems = pagerItems;

      listItems.childNodes.forEach((node, index) => {
        node.addEventListener('touchstart', handleTouchStart, false);
        node.addEventListener('touchmove', handleTouchMove, false);
      });
    });
  }
};

export default slider;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/slider.js